import { AbstractControl, ValidationErrors } from '@angular/forms';

export const base64 = (control: AbstractControl): ValidationErrors | null => {
  const key = 'base64';

  const value = control.value;

  if (!value) return null;

  const result =
    /^(?:[A-Z0-9+/]{4})*(?:[A-Z0-9+/]{2}==|[A-Z0-9+/]{3}=|[A-Z0-9+/]{4})$/i.test(
      value
    );

  if (!result)
    return {
      [key]: true,
    };

  return null;
};
